import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { AutoRotatingCarousel, Slide } from 'material-auto-rotating-carousel';
import { fetchAllStations } from '../redux/actions/userActions';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const AutoRotatingCarouselModal = ({ setUserLocation }) => {
  const [myOpen, setValue] = useState(true);
  const matches = useMediaQuery('(max-width:600px)');

  if (!matches) {
    //do CSS changes to the starter screens .AutoRotatingCarousel-carouselWrapper-8
    document.addEventListener('DOMContentLoaded', function(event) {
      const d = document.getElementsByClassName(
        'MuiPaper-root AutoRotatingCarousel-carouselWrapper-8 MuiPaper-elevation1 MuiPaper-rounded'
      );
      const se = document.getElementsByClassName(
        'AutoRotatingCarousel-carousel-17'
      );
      const other = document.getElementsByClassName(
        'AutoRotatingCarousel-content-2'
      );
      const mobile = document.getElementsByClassName('jss3 > .jss8');
      //const notMobile = document.getElementsByClassName("jss8")

      if (d.length > 0) {
        //notMobile[0].style.height="137%"
        d[0].style.height = '150%';
        se[0].style.height = '115%';
        other[0].style.top = '37%';
      }
      // if(mobile.length > 0){
      //   mobile[0].style.height="100%"
      //   notMobile[0].style.height="137%"
      // }
    });
  }

  const showError = () => {};
  const showPosition = (position) => {
    const { coords } = position;

    const add = {
      latitude: coords.latitude,
      longitude: coords.longitude,
    };

    setUserLocation(add);

    //dispatch users location to redux
    //TODO
  };

  const getLocation = (e) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    }
    setValue(false);
  };

  //doLocation("2222");
  return (
    <div>
      {/* <Button onClick={() => setHandleOpen({ open: true })}>Open carousel</Button> */}

      <AutoRotatingCarousel
        label="Get started"
        open={myOpen}
        onClose={() => setValue(false)}
        onStart={getLocation}
        autoplay={false}
        mobile={matches}
        containerStyle={{
          paddingTop: '2vh',
          paddingBottom: '5vh',
        }}
      >
        <Slide
          media={<img style={{ width: '' }} src="/onboard-1.png" />}
          mediaBackgroundStyle={{ backgroundColor: '#1976d200' }}
          style={{ backgroundColor: '#1976d200' }}
          title="Explore"
          subtitle="Find your favorite food truck closest to your location."
        />
        <Slide
          media={<img style={{ width: '' }} src="/onboard-2.png" />}
          mediaBackgroundStyle={{ backgroundColor: '#1976d200' }}
          style={{ backgroundColor: '#1976d200' }}
          title="Secured Payments"
          subtitle="Order online from your favorite food truck now!"
        />
        <Slide
          media={<img style={{ width: '' }} src="/onboard-3.png" />}
          mediaBackgroundStyle={{ backgroundColor: '#1976d200' }}
          style={{ backgroundColor: '#1976d200' }}
          title="Skip the line"
          subtitle=""
        />
      </AutoRotatingCarousel>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    chargingStations: state.user.chargingStations,
    userLocation: state.user.userLocation,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setInitialStations: () => dispatch(fetchAllStations()),
    setUserLocation: (location) => {
      dispatch({ type: 'SET_USER_LOCATION', location: location });
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AutoRotatingCarouselModal);
